import { render, staticRenderFns } from "./referidos.vue?vue&type=template&id=46ce93a2&scoped=true&"
import script from "./referidos.vue?vue&type=script&lang=js&"
export * from "./referidos.vue?vue&type=script&lang=js&"
import style0 from "./referidos.vue?vue&type=style&index=0&id=46ce93a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ce93a2",
  null
  
)

export default component.exports